import {useMapLayerConfig} from "base/map/layer";
import {useWMSLayer} from "base/map/leaflet/layer";
import {createWMSLegend, createWMSLegendIcon} from "base/map/legend";

export const baseLayerUrl = process.env.REACT_APP_QGIS_SERVER;

export function createBasePlotLegend() {
    return createWMSLegend({
        code: "capa_base",
        label: "Camadas base",
        children: [
            createWMSLegend({
                code: "arboles",
                layerCodes: ["app_mothertree"],
                label: "Árvores matriz",
                icon: createWMSLegendIcon({
                    type: "image",
                    src: "/map/icons/tree.svg",
                    style: {
                        filter: "invert(10%) sepia(63%) saturate(18%) hue-rotate(115deg) brightness(90%) contrast(91%)",
                    },
                }),
            }),
            createWMSLegend({
                code: "parcelas_base",
                label: "Parcelas base",
                children: [
                    createWMSLegend({
                        code: "privado_gleba",
                        layerCodes: ["app_privadogleba"],
                        label: "Privado - Gleba",
                        icon: createWMSLegendIcon({
                            type: "square",
                            style: {
                                color: "#ff73e1",
                                fillColor: "#ff73e1",
                                fillOpacity: 0.5,
                            },
                        }),
                    }),
                    createWMSLegend({
                        code: "media_empresa",
                        layerCodes: ["app_mediaempresa"],
                        label: "Estatal - Media empresas",
                        icon: createWMSLegendIcon({
                            type: "square",
                            style: {
                                color: "#9489ff",
                                fillColor: "#9489ff",
                                fillOpacity: 0.5,
                            },
                        }),
                    }),
                    createWMSLegend({
                        code: "parcela_agricola",
                        layerCodes: ["app_parcelaagricola"],
                        label: "Estatal - Parcelas agrícolas",
                        icon: createWMSLegendIcon({
                            type: "square",
                            style: {
                                color: "#75c178",
                                fillColor: "#75c178",
                                fillOpacity: 0.5,
                            },
                        }),
                    }),
                    createWMSLegend({
                        code: "modulo_pinheira",
                        layerCodes: ["app_modulopinheira"],
                        label: "Estatal - Modulos pinheira",
                        icon: createWMSLegendIcon({
                            type: "square",
                            style: {
                                color: "#58a46c",
                                fillColor: "#58a46c",
                                fillOpacity: 0.5,
                            },
                        }),
                    }),
                ],
            }),
            createWMSLegend({
                code: "landcover",
                layerCodes: ["app_landcover"],
                label: "Cobertura do solo",
                visible: false,
                showGraphic: true,
            }),
            createWMSLegend({
                code: "protected_area",
                layerCodes: ["app_protectedarea"],
                label: "Áreas protegidas",
                visible: false,
                showGraphic: true,
            }),
            createWMSLegend({
                code: "limites",
                layerCodes: ["app_district", "app_subdistrict"],
                label: "Limites administrativos",
            }),
            createWMSLegend({
                code: "hidrologia",
                label: "Hidrologia",
                visible: false,
                children: [
                    createWMSLegend({
                        code: "river",
                        layerCodes: ["app_river"],
                        label: "Rios",
                        icon: createWMSLegendIcon({
                            type: "line",
                            style: {
                                color: "#5bb8ff",
                                weight: 5,
                            },
                        }),
                    }),
                    createWMSLegend({
                        code: "basin",
                        layerCodes: ["app_basin"],
                        label: "Bacias",
                        icon: createWMSLegendIcon({
                            type: "polygon",
                            // TODO:egago Pending migration from CSS to SVG
                            style: {
                                borderColor: "#5bb8ff",
                                backgroundColor: "#5bb8ff",
                            },
                        }),
                        showGraphic: true,
                    }),
                ],
            }),
        ],
    });
}

export function createBasePlotLayer() {
    return useWMSLayer({
        format: "image/png",
        opacity: 1,
        pane: 2,
        otherLayerOptions: {
            tileSize: 1024,
            transparent: true,
            // crs: L.CRS.EPSG4326,
            minZoom: 8,
            tiled: true,
        },
    });
}

export function createBasePlotLayerConfig() {
    const baseLayerLoad = baseLayerUrl;

    const basePlotLayer = createBasePlotLayer();
    const basePlotLegend = createBasePlotLegend();
    return useMapLayerConfig({
        load: baseLayerLoad,
        layer: basePlotLayer,
        legend: basePlotLegend,
    });
}
